import React from 'react';
import { HelpCircle } from 'lucide-react';
import { FAQ } from '@/data/manual/staffManual';

export const FaqChapter = ({ query = '' }) => {
  const q = query.toLowerCase();
  const items = FAQ.filter((f) => !q || `${f.q} ${f.a}`.toLowerCase().includes(q));
  if (!items.length) return null;
  return (
    <section id="faq" data-testid="help-faq" className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-6 scroll-mt-28 print-break">
      <header className="flex items-center gap-3">
        <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-slate-700 text-white shrink-0"><HelpCircle className="w-5 h-5" /></span>
        <h3 className="text-xl sm:text-2xl font-bold text-[#27292E]">Frequently asked</h3>
      </header>
      <dl className="mt-4 divide-y divide-gray-100">
        {items.map((f, i) => (
          <div key={i} className="py-3 break-inside-avoid" data-testid={`faq-${i}`}>
            <dt className="text-sm font-semibold text-[#27292E]">{f.q}</dt>
            <dd className="text-sm text-gray-700 mt-1">{f.a}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
